import { useReviewsContext } from "../context/reviews.context";
import { useWriteReviewContext } from "../context/writeReview.context";
import { CreateReviewComponent } from "./createReview.component";

export const CreateReview = () => {
    const { range } = useReviewsContext();

    const { reviewSubmission, open } = useWriteReviewContext();

    return (
        <CreateReviewComponent
            rating={reviewSubmission?.rating ?? 0}
            range={range}
            writeReview={open}
        />
    );
};
